import {
  require_classnames
} from "./chunk-PXJBVWC7.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues,
  __toESM
} from "./chunk-WI73T6NA.mjs";

// src/card/content.tsx
import styled2 from "@emotion/styled";

// src/card/footer.tsx
var import_classnames = __toESM(require_classnames());
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
var CardFooterWrapper = styled.div`
  &.pq-card__footer {
    box-shadow: 0 -2px 24px 0 rgba(223, 231, 255, 0.2);
    background-color: #ffffff;
    border-radius: 16px;
    display: flex;
    width: 100%;
    padding: 0;
    margin: 0 auto;
  }
`;
var CardFooter = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames.default)("pq-card__footer", className);
  return /* @__PURE__ */ jsx(CardFooterWrapper, __spreadProps(__spreadValues({ className: classes }, rest), { children: /* @__PURE__ */ jsx(
    "div",
    {
      css: css`
          width: 85%;
          margin: 0 auto;
        `,
      children
    }
  ) }));
};
var footer_default = CardFooter;

// src/card/content.tsx
var import_classnames2 = __toESM(require_classnames());
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
var CardContentWrapper = styled2.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  overflow-wrap: anywhere;
  word-break: normal;
`;
var CardContent = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames2.default)("pq-card__content", className);
  return /* @__PURE__ */ jsx2(CardContentWrapper, __spreadProps(__spreadValues({ className: classes }, rest), { children }));
};
CardContent.Footer = footer_default;

// src/card/header-actions.tsx
var import_classnames3 = __toESM(require_classnames());
import styled3 from "@emotion/styled";
import { jsx as jsx3 } from "@emotion/react/jsx-runtime";
var CardHeaderActions = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames3.default)("pq-card__header-actions", className);
  return /* @__PURE__ */ jsx3(CardHeaderActionsWrapper, __spreadProps(__spreadValues({ className: classes }, rest), { children }));
};
var CardHeaderActionsWrapper = styled3.div``;

// src/card/header-title.tsx
var import_classnames4 = __toESM(require_classnames());
import { createElement } from "react";
var CardHeaderTitle = (props) => {
  const _a = props, { children, as, className } = _a, rest = __objRest(_a, ["children", "as", "className"]);
  const classes = (0, import_classnames4.default)("pq-card__header-title", className);
  return createElement(
    as,
    __spreadValues({
      className: classes
    }, rest),
    children
  );
};

// src/card/header.tsx
var import_classnames5 = __toESM(require_classnames());
import styled4 from "@emotion/styled";
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
var CardHeader = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames5.default)("pq-card__header", className);
  return /* @__PURE__ */ jsx4(CardHeaderWrapper, __spreadProps(__spreadValues({ className: classes }, rest), { children }));
};
var CardHeaderWrapper = styled4.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
var CardHeaderNamespace = Object.assign(CardHeader, {
  Title: CardHeaderTitle,
  Actions: CardHeaderActions
});

// src/card/index.tsx
var import_classnames6 = __toESM(require_classnames());
import styled5 from "@emotion/styled";
import { forwardRef } from "react";
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
var CardWrapper = styled5.div`
  &.pq-card {
    border-radius: 16px;
    background-color: #ffffff;
  }
`;
var Card = forwardRef((props, forwardedRef) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  const classes = (0, import_classnames6.default)("pq-card", className);
  return /* @__PURE__ */ jsx5(CardWrapper, __spreadProps(__spreadValues({ className: classes }, rest), { ref: forwardedRef, children }));
});
Card.displayName = "Card";
var CardNamespace = Object.assign(Card, {
  Header: CardHeaderNamespace,
  Content: CardContent,
  Footer: footer_default
});

export {
  CardNamespace
};
//# sourceMappingURL=chunk-YRD5K5ZZ.mjs.map